import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-07947fbb"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "micro-detail-wrapper"
};
const _hoisted_2 = {
  class: "wrapper-cont-fa"
};
const _hoisted_3 = {
  class: "wrapper-cont-li leftCont"
};
const _hoisted_4 = {
  class: "menu-list-fa"
};
const _hoisted_5 = {
  class: "wrapper-cont-li rightCont"
};
const _hoisted_6 = ["id"];
const _hoisted_7 = ["id"];
const _hoisted_8 = ["id"];
const _hoisted_9 = ["id"];
const _hoisted_10 = ["id"];
const _hoisted_11 = ["id"];
const _hoisted_12 = ["id"];
const _hoisted_13 = ["id"];
const _hoisted_14 = ["id"];
const _hoisted_15 = ["id"];
const _hoisted_16 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_anchor_link = _resolveComponent("a-anchor-link");

  const _component_a_anchor = _resolveComponent("a-anchor");

  const _component_LaborDetail1 = _resolveComponent("LaborDetail1");

  const _component_LaborDetail2 = _resolveComponent("LaborDetail2");

  const _component_LaborDetail3 = _resolveComponent("LaborDetail3");

  const _component_LaborDetail4 = _resolveComponent("LaborDetail4");

  const _component_LaborDetail5 = _resolveComponent("LaborDetail5");

  const _component_LaborDetail6 = _resolveComponent("LaborDetail6");

  const _component_LaborDetail7 = _resolveComponent("LaborDetail7");

  const _component_LaborDetail8 = _resolveComponent("LaborDetail8");

  const _component_LaborDetail9 = _resolveComponent("LaborDetail9");

  const _component_LaborDetail10 = _resolveComponent("LaborDetail10");

  const _component_LaborDetail11 = _resolveComponent("LaborDetail11");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_anchor, {
    affix: true,
    onChange: $options.onAnchorChange,
    onClick: $options.onAnchorClick,
    wrapperClass: "labor-anchor-wrapper"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuListTrue, item => {
      return _openBlock(), _createBlock(_component_a_anchor_link, {
        key: item.id,
        title: item.name,
        href: '#' + item.id,
        class: _normalizeClass(['menu-li', $data.activeItem === item.id ? 'activeItem' : ''])
      }, null, 8, ["title", "href", "class"]);
    }), 128))]),
    _: 1
  }, 8, ["onChange", "onClick"])])]), _createElementVNode("div", _hoisted_5, [$options.computedShowLaborDetail1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "rightCont-main",
    id: $data.menuList['laborDetail1'].id
  }, [_createVNode(_component_LaborDetail1, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail1'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_6)) : _createCommentVNode("", true), $options.computedShowLaborDetail2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "rightCont-main",
    id: $data.menuList['laborDetail2'].id
  }, [_createVNode(_component_LaborDetail2, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail2'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_7)) : _createCommentVNode("", true), $options.computedShowLaborDetail3 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "rightCont-main",
    id: $data.menuList['laborDetail3'].id
  }, [_createVNode(_component_LaborDetail3, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail3'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_8)) : _createCommentVNode("", true), $options.computedShowLaborDetail4 ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "rightCont-main",
    id: $data.menuList['laborDetail4'].id
  }, [_createVNode(_component_LaborDetail4, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail4'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_9)) : _createCommentVNode("", true), $options.computedShowLaborDetail5 ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: "rightCont-main",
    id: $data.menuList['laborDetail5'].id
  }, [_createVNode(_component_LaborDetail5, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail5'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_10)) : _createCommentVNode("", true), $options.computedShowLaborDetail6 ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: "rightCont-main",
    id: $data.menuList['laborDetail6'].id
  }, [_createVNode(_component_LaborDetail6, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail6'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_11)) : _createCommentVNode("", true), $options.computedShowLaborDetail7 ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "rightCont-main",
    id: $data.menuList['laborDetail7'].id
  }, [_createVNode(_component_LaborDetail7, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail7'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_12)) : _createCommentVNode("", true), $options.computedShowLaborDetail8 ? (_openBlock(), _createElementBlock("div", {
    key: 7,
    class: "rightCont-main",
    id: $data.menuList['laborDetail8'].id
  }, [_createVNode(_component_LaborDetail8, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail8'].name,
    "file-list": $data.fileList
  }, null, 8, ["laboratory-item-detail", "moudle-name", "file-list"])], 8, _hoisted_13)) : _createCommentVNode("", true), $options.computedShowLaborDetail9 ? (_openBlock(), _createElementBlock("div", {
    key: 8,
    class: "rightCont-main",
    id: $data.menuList['laborDetail9'].id
  }, [_createVNode(_component_LaborDetail9, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail9'].name
  }, null, 8, ["laboratory-item-detail", "moudle-name"])], 8, _hoisted_14)) : _createCommentVNode("", true), $options.computedShowLaborDetail10 ? (_openBlock(), _createElementBlock("div", {
    key: 9,
    class: "rightCont-main",
    id: $data.menuList['laborDetail10'].id
  }, [_createVNode(_component_LaborDetail10, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail10'].name,
    "case-list": $data.caseList
  }, null, 8, ["laboratory-item-detail", "moudle-name", "case-list"])], 8, _hoisted_15)) : _createCommentVNode("", true), $options.computedShowLaborDetail11 ? (_openBlock(), _createElementBlock("div", {
    key: 10,
    class: "rightCont-main",
    id: $data.menuList['laborDetail11'].id
  }, [_createVNode(_component_LaborDetail11, {
    "laboratory-item-detail": $props.laboratoryItemDetail,
    "moudle-name": $data.menuList['laborDetail11'].name,
    "record-orgin-list": $data.recordOrginList
  }, null, 8, ["laboratory-item-detail", "moudle-name", "record-orgin-list"])], 8, _hoisted_16)) : _createCommentVNode("", true)])])]);
}